import "./App.css";
import LandingPage from "./pages/landing-page";

function App() {
  return <LandingPage />;
}

export default App;
